var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"downBtn",attrs:{"size":"small","type":_vm.type,"icon":_vm.icon},on:{"click":function($event){$event.stopPropagation();_vm.download(_vm.data)}}},[_vm._t("ButtonName")],2)}
var staticRenderFns = []

export { render, staticRenderFns }